// import React, { useState, useEffect } from "react";
// import {
//     Box,   
//     Divider,

// } from "@mui/material";

// import CallAlertBar from "../../../Layout/Alertbar";
// import ViewMonthlyAttendanceActionMenu from "./ViewMonthlyAttendanceActionMenu";


// const ViewMonthlyAttendance = ({ handlecallBack}) => {  

//     const [errorMessages, setErrorMessages] = useState({});
//     const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
//     const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
//     const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
//     const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');


//     const [title, setTitle] = useState('New Attendance Entry');

//     const ViewHideMsg = (msg, securityvalue, open) => {
//         setParentRollSeverityvalue(securityvalue);
//         setParentRollMessageValue(msg);
//         setParentRollAlertTitleValue(securityvalue);
//         setParentRollMsgOpen(open);
//     }


//     const ClearAll = async () => {

//     };

//     const [selectedButtonName, setSelectedButtonName] = useState('');

//     const handlecallProcess = (buttonName) => {
//         if (buttonName === 'report') {

//         }

//         else if (buttonName === 'save') {           
//             // handleSubmit();
//         }
//         else if (buttonName === 'clear') {
//             ClearAll();
//         }

//     }

//     return (
//         <Box padding={0}>

//             <ViewMonthlyAttendanceActionMenu selectedButtonName={selectedButtonName} setSelectedButtonName={setSelectedButtonName} handlecallProcess={handlecallProcess} title={'View Monthly Attendance Detail'} callback={handlecallBack} />
//             <Divider />

//             {/* Message box detail */}
//             <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
//                 setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
//                 setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


//             <Box padding={1}>


//             </Box>            
//         </Box>
//     );
// };

// export default ViewMonthlyAttendance;


import React, { useState, useEffect } from "react";
import {
    Box,
    Divider,
    Grid,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TextField,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    useTheme,
    Menu,
    Button,
    ButtonGroup,
    Stack
} from "@mui/material";

import CallAlertBar from "../../../Layout/Alertbar";
import ViewMonthlyAttendanceActionMenu from "./ViewMonthlyAttendanceActionMenu";
import useHRMonthWiseEmployeeAttendance from "../../../hooks/useHRMonthWiseEmployeeAttendance";
import useEmployee from "../../../hooks/useEmployee";
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import { tokens } from "../../../theme/theme";
import ResponsiveBox from "../../../components/form/ResponsiveScrollBox";
import { exportAttendanceToExcel } from "./ExportEmployeeAttendance";
import { generateAttendancePDF } from "./GenerateAttendanceReport";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import FileDownloadIcon from "@mui/icons-material/FileDownload";


const ViewMonthlyAttendance = ({ handlecallBack }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [errorMessages, setErrorMessages] = useState({});
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking!');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [title, setTitle] = useState('New Attendance Entry');
    const [anchorEl, setAnchorEl] = useState(null);

    const [selectedCustomer, setSelectedCustomer] = useState('');
    const [selectedCustomerID, setSelectedCustomerID] = useState('');
    const [selectedMonthYear, setSelectedMonthYear] = useState(""); // format: "2025-07"

    const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID, } = useEmployee(0);
    const { attendanceList, setAttendanceList, isDataLoaded, setIsDataLoaded, loading, handleEmployeeMonthWiseAttendance, presentDays, absentDays, halfDayLeaves, hourPermissions, fullLeaveDays,holiDays } = useHRMonthWiseEmployeeAttendance();

    const ViewHideMsg = (msg, securityvalue, open) => {
        setParentRollSeverityvalue(securityvalue);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(securityvalue);
        setParentRollMsgOpen(open);
    };

    const ClearAll = async () => {
        setSelectedCustomer('');
        setSelectedMonthYear('');
    };

    const [selectedButtonName, setSelectedButtonName] = useState('');

    const handlecallProcess = (buttonName) => {
        if (buttonName === 'download') {

            // Excel Export Data
            // exportAttendanceToExcel({
            //     employee: selectedCustomer,
            //     selectedMonth: selectedMonthYear,
            //     summary: {
            //         present_days: presentDays,
            //         absent_days:absentDays,
            //         leave_days: fullLeaveDays,
            //         half_day_leaves: halfDayLeaves,
            //         hour_permission: hourPermissions
            //     },
            //     attendanceList
            // });

            // PDF Export Data
            // generateAttendancePDF({
            //     employee: selectedCustomer,
            //     selectedMonth: selectedMonthYear,
            //     summary: {
            //         present_days: presentDays,
            //         absent_days: absentDays,
            //         leave_days: fullLeaveDays,
            //         half_day_leaves: halfDayLeaves,
            //         hour_permission: hourPermissions
            //     },
            //     attendanceList
            // });

        } else if (buttonName === 'clear') {
            ClearAll();
        } else if (buttonName === 'pdf') {
            handleExportPDF();
        }
        else if (buttonName === 'excel') {
            handleExportExcel();
        }
    };


    // Handle Load
    const handleLoadData = async () => {
        if (!selectedCustomerID || !selectedMonthYear) {
            alert("Please select both employee and month.");
            return;
        }

        const [year, month] = selectedMonthYear.split("-");

        const payload = {
            p_company_id: parseInt(localStorage.getItem('companyid') || "0"),
            p_plant_id: 1,
            p_employee_id: selectedCustomerID,
            p_month: parseInt(month, 10),
            p_year: parseInt(year, 10),
        };

        try {
            await handleEmployeeMonthWiseAttendance(payload);
        } catch (error) {
            console.error("Failed to load attendance:", error);
        }
    };

    // Auto trigger on both selection
    useEffect(() => {
        if (selectedCustomerID && selectedMonthYear) {
            handleLoadData();
        }
    }, [selectedCustomerID, selectedMonthYear]);


    // export attendance list

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (option) => {
        setAnchorEl(null);
        if (option === 'pdf') handleExportPDF();
        if (option === 'excel') handleExportExcel();
    };

    const handleExportPDF = () => {
        generateAttendancePDF({
            employee: selectedCustomer,
            selectedMonth: selectedMonthYear,
            summary: {
                present_days: presentDays,
                absent_days: absentDays,
                leave_days: fullLeaveDays,
                half_day_leaves: halfDayLeaves,
                hour_permission: hourPermissions
            },
            attendanceList
        });
    }

    const handleExportExcel = () => {

        exportAttendanceToExcel({
            employee: selectedCustomer,
            selectedMonth: selectedMonthYear,
            summary: {
                present_days: presentDays,
                absent_days: absentDays,
                leave_days: fullLeaveDays,
                half_day_leaves: halfDayLeaves,
                hour_permission: hourPermissions
            },
            attendanceList
        });


    }


    return (
        <Box padding={0}>
            <ViewMonthlyAttendanceActionMenu
                selectedButtonName={selectedButtonName}
                setSelectedButtonName={setSelectedButtonName}
                handlecallProcess={handlecallProcess}
                title={'View Monthly Attendance Detail'}
                callback={handlecallBack}
            />
            <Divider />
            <CallAlertBar
                parentRollMsgOpen={parentRollMsgOpen}
                setParentRollMsgOpen={setParentRollMsgOpen}
                parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue}
                parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue}
                parentRollMessageValue={parentRollMessageValue}
                setParentRollMessageValue={setParentRollMessageValue}
            />

            <Box padding={2}>
                {/* Filters */}
                <Grid container spacing={2}>

                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel shrink>Customer Code</InputLabel>
                            <Select
                                value={selectedCustomer}
                                onChange={(e) => {
                                    setSelectedCustomer(e.target.value);
                                    setSelectedCustomerID(e.target.value.id);
                                }}
                                label="Customer Code"
                            >
                                {employee.map((cust) => (
                                    <MenuItem key={cust.id} value={cust}>
                                        {cust.code} - {cust.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <FormControl fullWidth size="small">
                            <TextField
                                label="Select Month"
                                type="month"
                                value={selectedMonthYear}
                                onChange={(e) => setSelectedMonthYear(e.target.value)}
                                InputLabelProps={{ shrink: true, color: 'secondary' }}
                                fullWidth
                                size="small"

                            />
                        </FormControl>
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={3} xl={2}>
                        <Stack direction="row" spacing={2}>
                            <ButtonGroup variant="contained" color="secondary">
                                <Button startIcon={<FileDownloadIcon />}>Export</Button>
                                <Button
                                    size="small"
                                    onClick={handleClick}
                                >
                                    <ArrowDropDownIcon />
                                </Button>
                            </ButtonGroup>
                            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                                <MenuItem onClick={() => handleClose('pdf')}>Export as PDF</MenuItem>
                                <MenuItem onClick={() => handleClose('excel')}>Export as Excel</MenuItem>
                            </Menu>
                        </Stack>
                    </Grid> */}


                </Grid>

                {/* Summary cards */}
                <Grid container spacing={2} marginTop={2}>
                    <Grid item xs={12} sm={4} md={2} xl={2}>
                        <Card variant="outlined" >
                            <CardContent>
                                <Typography variant="h6">Present Days</Typography>
                                <Typography variant="h5">{presentDays}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} xl={2}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="h6">Absent Days</Typography>
                                <Typography variant="h5">{absentDays}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} xl={2}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="h6">Leave Days</Typography>
                                <Typography variant="h5">{fullLeaveDays}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} xl={2}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="h6">Half Day Leaves</Typography>
                                <Typography variant="h5">{halfDayLeaves}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={4} md={2} xl={2}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="h6">Hour Permission</Typography>
                                <Typography variant="h5">{hourPermissions}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                     <Grid item xs={12} sm={4} md={2} xl={2}>
                        <Card variant="outlined">
                            <CardContent>
                                <Typography variant="h6">Holidays</Typography>
                                <Typography variant="h5">{holiDays}</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Attendance Table */} 
                <Box marginTop={3}>
                    <Box sx={{ backgroundColor: colors.primary[400] }}>
                        <Typography variant="h6" sx={{ padding: '5px' }} gutterBottom>Monthly Attendance Detail</Typography>
                    </Box>

                    {/* <Divider /> */}
                    <ResponsiveBox customMaxHeight={{
                        xs: '72vh', // Extra small devices (phones)
                        sm: '72vh', // Small devices (tablets)
                        md: '60vh', // Medium devices (small laptops)
                        lg: '47vh', // Large devices (desktops)
                        xl: '64vh', // Extra large devices (large desktops)
                    }}>

                        <CustomTableContainer colors={colors}>
                            <TableContainer >
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>DATE</TableCell>
                                            <TableCell>STATUS</TableCell>
                                            <TableCell>CHECK-IN-DATE</TableCell>
                                            <TableCell>CHECK-IN-TIME</TableCell>
                                            <TableCell>CHECK-OUT-DATE</TableCell>
                                            <TableCell>CHECK-OUT-TIME</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {attendanceList?.map((row, index) => {
                                            const isInvalid = (val) =>
                                                !val || val === '0001-01-01' || val === '0001-01-01T00:00:00';

                                            const formatDate = (dateString) => {
                                                if (isInvalid(dateString)) return '-';
                                                const date = new Date(dateString);
                                                return date.toLocaleDateString("en-GB", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric"
                                                }).replace(/ /g, "-"); // Converts to dd-MMM-yyyy
                                            };

                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>{formatDate(row?.att_date)}</TableCell>
                                                    <TableCell>{row?.status || '-'}</TableCell>
                                                    <TableCell>{formatDate(row?.check_in_date)}</TableCell>
                                                    <TableCell>{isInvalid(row?.check_in_time) ? '-' : row.check_in_time}</TableCell>
                                                    <TableCell>{formatDate(row?.check_out_date)}</TableCell>
                                                    <TableCell>{isInvalid(row?.check_out_time) ? '-' : row.check_out_time}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox>
                </Box>
            </Box>
        </Box>
    );
};

export default ViewMonthlyAttendance;

